import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export class Footer {
  constructor() {
    gsap.registerPlugin(ScrollTrigger)
    this.init()
  }

  init() {
    const footer = document.querySelector('.l-footer')
    const cta = footer.querySelector('.l-footer__cta')
    const ctaSlider = footer.querySelector('.l-footer__cta__slider')
    const ctaHeadInfo = footer.querySelector('.c-cta__head__info')
    const ctaInfoChildren = ctaHeadInfo ? [...ctaHeadInfo.children] : []
    const ctaHeadImage = footer.querySelector('.c-cta__head__image')
    const ctaButtons = [...footer.querySelectorAll('.c-cta__button')]
    const footerBottom = footer.querySelector('.l-footer__bottom')
    const footerInfo = footer.querySelector('.l-footer__info')
    const copy01 = footer.querySelector('.l-footer__bottom__copy .copy01')
    const copy02 = footer.querySelector('.l-footer__bottom__copy .copy02')
    const bgBlue = footer.querySelector('.bg-blue')
    const boy = footer.querySelector('.boy')
    const girl = footer.querySelector('.girl')
    const rect01 = footer.querySelector('.bg-dot.-rectangle01')
    const rect02 = footer.querySelector('.bg-dot.-rectangle02')

    const isSP = window.matchMedia('(max-width: 1023px)').matches

    if (isSP) {
      this.initSP({
        cta, ctaSlider, ctaInfoChildren, ctaHeadImage, ctaButtons,
        footerBottom, footerInfo, copy01, copy02, bgBlue, boy, girl, rect01, rect02
      })
      return
    }

    // ── 初期状態 ──────────────────────────────────────
    gsap.set(cta, { opacity: 0 })
    gsap.set(ctaSlider, { opacity: 0, y: 40 })
    gsap.set(ctaInfoChildren, { opacity: 0, y: 30 })
    gsap.set(ctaHeadImage, { opacity: 0, y: 60, rotateY: -45, transformPerspective: 800 })
    gsap.set(ctaButtons, { opacity: 0, y: 30 })
    gsap.set(footerBottom, { opacity: 0 })
    gsap.set(footerInfo, { opacity: 0 })
    gsap.set(copy01, { opacity: 0, x: -60 })
    gsap.set(copy02, { opacity: 0, x: 60 })
    gsap.set(bgBlue, { opacity: 0, scale: 0, transformOrigin: 'center center' })
    gsap.set(boy, { opacity: 0, y: 60 })
    gsap.set(girl, { opacity: 0 })
    gsap.set(rect01, { opacity: 0, y: 30 })
    gsap.set(rect02, { opacity: 0, y: 30 })

    // ── メインタイムライン（scrub連動） ───────────────
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: footer,
        start: 'top top',
        end: '+=400%',
        pin: true,
        pinSpacing: true,
        scrub: true, 
        anticipatePin: 1,
        onLeave: () => {
          gsap.to(footer, { opacity: 1, duration: 0 })
        },
      },
    })

    tl.to(cta, { opacity: 1, duration: 1 })
    tl.to(ctaSlider, { opacity: 1, y: 0, duration: 1 }, '-=0.5')
    tl.to(ctaInfoChildren, { opacity: 1, y: 0, duration: 0.8, stagger: 0.3 }, '-=0.3')
    tl.to(ctaHeadImage, { opacity: 1, y: 0, rotateY: 0, duration: 1.2, ease: 'power2.out' }, '-=0.3')
    tl.to(ctaButtons, { opacity: 1, y: 0, duration: 0.8, stagger: 0.3 }, '-=0.3')
    tl.to({}, { duration: 2 })
    tl.to(ctaHeadImage, { opacity: 0, y: -60, duration: 0.8 })
    tl.to([...ctaInfoChildren, ...ctaButtons, ctaSlider], { opacity: 0, y: -40, duration: 0.8, stagger: 0.1 }, '-=0.5')
    tl.to(cta, { opacity: 0, duration: 0.5 }, '-=0.3')
    tl.call(() => {
      footerInfo.style.background =
        'linear-gradient(0deg, #222 0%, rgba(34, 34, 34, 0.50) 60%, rgba(34, 34, 34, 0.00) 100%)'
    })
    tl.to(footerBottom, { opacity: 1, duration: 0.5 }, '<')
    tl.to(footerInfo, { opacity: 1, duration: 0.8 }, '<')
    tl.to(copy01, { opacity: 1, x: 0, duration: 1 }, '-=0.3')
    tl.to(copy02, { opacity: 1, x: 0, duration: 1 }, '<')
    tl.to(bgBlue, { opacity: 1, scale: 1, duration: 1.2, ease: 'back.out(1.7)' }, '<')
    tl.to(boy, { opacity: 1, y: 0, duration: 1, ease: 'power2.out' }, '-=0.5')
    tl.to(girl, { opacity: 1, duration: 0.4 }, '-=0.5')
    tl.to(rect01, { opacity: 1, y: 0, duration: 0.8 }, '<')
    tl.to(rect02, { opacity: 1, y: 0, duration: 0.8, delay: 0.15 }, '<')
    tl.to({}, { duration: 3 }) // バッファ：ピン解除時のカクン防止
  }

  initSP({ cta, ctaSlider, ctaInfoChildren, ctaHeadImage, ctaButtons,
          footerBottom, footerInfo, copy01, copy02, bgBlue, boy, girl, rect01, rect02 }) {

    // 初期状態
    gsap.set(cta, { opacity: 0 })
    gsap.set(ctaSlider, { opacity: 0, y: 40 })
    gsap.set(ctaInfoChildren, { opacity: 0, y: 30 })
    gsap.set(ctaHeadImage, { opacity: 0, y: 60, rotateY: -45, transformPerspective: 800 })
    gsap.set(ctaButtons, { opacity: 0, y: 30 })
    gsap.set(footerBottom, { opacity: 0 })
    gsap.set(footerInfo, { opacity: 0 })
    gsap.set(copy01, { opacity: 0, x: -60 })
    gsap.set(copy02, { opacity: 0, x: 60 })
    gsap.set(bgBlue, { opacity: 0, scale: 0, rotate: -32 })
    gsap.set(boy, { opacity: 0, y: 60 })
    gsap.set(girl, { opacity: 0 })
    gsap.set(rect01, { opacity: 0, y: 30 })
    gsap.set(rect02, { opacity: 0, y: 30 })

    const trigger = (el, anim, start = 'top 85%') => ({
      ...anim,
      scrollTrigger: {
        trigger: el,
        start,
        toggleActions: 'play none none none',
      }
    })

    // CTA
    gsap.to(cta, trigger(cta, { opacity: 1, duration: 0.6 }))
    gsap.to(ctaSlider, trigger(cta, { opacity: 1, y: 0, duration: 0.6, delay: 0.2 }))
    gsap.to(ctaInfoChildren, trigger(cta, { opacity: 1, y: 0, duration: 0.6, stagger: 0.15, delay: 0.3 }))
    gsap.to(ctaHeadImage, trigger(cta, { opacity: 1, y: 0, rotateY: 0, duration: 0.8, ease: 'power2.out', delay: 0.4 }))
    gsap.to(ctaButtons, trigger(cta, { opacity: 1, y: 0, duration: 0.6, stagger: 0.15, delay: 0.5 }))

    // bottom
    footerInfo.style.background =
      'linear-gradient(0deg, #222 0%, rgba(34, 34, 34, 0.50) 60%, rgba(34, 34, 34, 0.00) 100%)'

    gsap.to(footerBottom, trigger(footerBottom, { opacity: 1, duration: 0.6 }))
    gsap.to(footerInfo, trigger(footerBottom, { opacity: 1, duration: 0.8, delay: 0.1 }))
    gsap.to(copy01, trigger(footerBottom, { opacity: 1, x: 0, duration: 0.8, delay: 0.2 }))
    gsap.to(copy02, trigger(footerBottom, { opacity: 1, x: 0, duration: 0.8, delay: 0.2 }))
    gsap.to(bgBlue, trigger(footerBottom, { opacity: 1, scale: 1, rotate: -32, duration: 1.0, ease: 'back.out(1.7)', delay: 0.3 }))
    gsap.to(boy, trigger(footerBottom, { opacity: 1, y: 0, duration: 0.8, ease: 'power2.out', delay: 0.4 }))
    gsap.to(girl, trigger(footerBottom, { opacity: 1, duration: 0.4, delay: 0.6 }))
    gsap.to(rect01, trigger(footerBottom, { opacity: 1, y: 0, duration: 0.6, delay: 0.5 }))
    gsap.to(rect02, trigger(footerBottom, { opacity: 1, y: 0, duration: 0.6, delay: 0.6 }))
  }
}